"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var SmileyNormal = function SmileyNormal(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.94368 8.47233C7.78768 8.47233 8.47135 7.78866 8.47135 6.94466C8.47135 6.10133 7.78768 5.41699 6.94368 5.41699C6.09968 5.41699 5.41602 6.10133 5.41602 6.94466C5.41602 7.78866 6.09968 8.47233 6.94368 8.47233Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.055 8.47233C13.899 8.47233 14.5827 7.78866 14.5827 6.94466C14.5827 6.10133 13.899 5.41699 13.055 5.41699C12.211 5.41699 11.5273 6.10133 11.5273 6.94466C11.527 7.78866 12.2107 8.47233 13.055 8.47233Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.583 12.2915H5.41634C4.99401 12.2915 4.65234 12.6338 4.65234 13.0555C4.65234 13.4772 4.99368 13.8195 5.41634 13.8195H14.583C15.0053 13.8195 15.347 13.4772 15.347 13.0555C15.347 12.6338 15.0053 12.2915 14.583 12.2915Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 19C5.03733 19 1 14.9627 1 10C1 5.03733 5.03733 1 10 1C14.9627 1 19 5.03733 19 10C19 14.9627 14.9627 19 10 19Z"
  }));
};
var _default = exports["default"] = SmileyNormal;